import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { useMedia } from '../../hooks/useMedia';
import { trackButtonClick } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileMerchCardSelectorButtons = ({
  options,
  onClick,
  selectedOption
}) => {
  const isMaxWidthPhoneLarge = useMedia('phoneLarge');
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: isMaxWidthPhoneLarge ? 'column' : 'row',
    inlineSize: "100%",
    gap: "100",
    children: options.map(option => {
      const messageKey = findValidI18nKey([`productLevel.${option}`, `merchCards.hubSpotCredits.CUSTOMER_AGENT.${option}.subtitle`]);
      if (!messageKey) {
        return null;
      }
      return /*#__PURE__*/_jsx(SelectableButton, {
        onClick: () => {
          trackButtonClick({
            value: option
          });
          onClick(option);
        },
        selected: selectedOption === option,
        block: true,
        children: /*#__PURE__*/_jsx(Text, {
          typography: selectedOption === option ? 'heading-25' : 'detail-200',
          as: "div",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: messageKey
          })
        })
      }, option);
    })
  });
};
export default MobileMerchCardSelectorButtons;